(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/View', 'templates', 'app/user/userService', 'app/widget/modal/UseModalBehavior', 'app/widget/modal/ModalDialogWidget', 'app/authentication/logoutUtils'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = {
      eregNavTemplate: require('./eregNavTemplate.hbs')
    };
    module.exports = factory(require('backbone-torso/modules/View'), templates, require('./../../user/userService'), require('./../../widget/modal/UseModalBehavior'), require('./../../widget/modal/ModalDialogWidget'), require('./../../authentication/logoutUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoView, templates, userService, UseModalBehavior, ModalDialogWidget, logoutUtils) {
  'use strict';

  /**
   * View to display the ereg patient nav
   *
   * @class eregNavView
   * @extends Torso.View
   * @constructor
   * @param options {Object} Options to configure this view.
   *   @param [options.isPatient=false] {Boolean} whether this is a patient-facing view or a staff-facing view.
   */
  return TorsoView.extend({
    tagName: 'nav',
    className: 'tablet-main-nav',
    moduleNamespace: 'eregPatientNav',
    template: templates.eregNavTemplate,

    events: {
      'click [data-home]' : '_home',
      'click [data-logout]' : '_logout'
    },

    behaviors: {
      useModalBehavior: {
        behavior: UseModalBehavior
      }
    },

    prepareFields: {
      isPatient: '_isPatient',
      hideSignOutBtn: '_hideSignOutBtn',
      firstName: function() { return userService.currentUserModel.get('firstName'); },
      lastName: function() { return userService.currentUserModel.get('lastName'); }
    },

    /**
     * @method initialize
     * @override
     * @param options {Object} Options to configure this view.
     *   @param [options.isPatient=false] {Boolean} whether this is a patient-facing view or a staff-facing view.
     *   @param [options.hideSignOutBtn=false] {Boolean} whether to hide the sign out button.
     */
    initialize: function(options) {
      options = options || {};
      this._isPatient = options.isPatient;
      this._hideSignOutBtn = options.hideSignOutBtn || false;
      if (!this._isPatient) {
        this._setAttributes({
          'class': this.className + ' tablet-main-nav--staff'
        });
      }
      this.listenTo(userService.currentUserModel, 'change:firstName change:lastName', this.render);
    },

    /**
     * @method _detach
     * @override
     */
    _detached: function() {
      if (this._modalDialogWidget) {
        this._modalDialogWidget.rejectModal();
      }
    },

    /**
     * Triggers the 'home' event on this view when called and passes the original DOM event as part of the payload.
     * @method _home
     * @param event the dom event that triggered this method.
     * @private
     */
    _home: function(event) {
      this.trigger('home', { domEvent: event });
    },

    /**
     * Instantiates a confirmation popup for logout, and logs the user out if it returns true.
     * @method _logout
     * @private
     */
    _logout: function() {
      this._modalDialogWidget = new ModalDialogWidget({
        dataViewName: 'confirm ereg signout',
        descriptionKey: 'nav.signOutModal.body',
        yesKey: 'nav.signOutModal.signOut',
        noKey: 'nav.signOutModal.stay'
      });
      this.showModal(this._modalDialogWidget, logoutUtils.patientLogoutWithRedirectToEreg);
    }
  });
}));
